'use client';

import React from 'react';
import { useSearchParams } from 'next/navigation';
import { SignIn } from '@clerk/nextjs';

const Page = () => {
  const searchParams = useSearchParams();
  const returnTo = searchParams.get('returnTo');

  return (
    <div
      id="sign-in-page"
      style={{
        width: '100%',
        height: '70vh',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          filter:
            'drop-shadow(0px -20px 90px rgba(140, 69, 255, 0.25)) drop-shadow(0px -19px 90px rgba(140, 69, 255, 0.4))',
        }}
      >
        <SignIn path="/sign-in" forceRedirectUrl={returnTo ?? '/jobs'} signUpUrl="/sign-up" />
      </div>
    </div>
  );
};

export default Page;
